import React from "react";

function formatDateTimeToDisplay(dateTimeStr) {
  if (!dateTimeStr) return "";
  const [date] = dateTimeStr.split(" "); // take only yyyy-mm-dd
  const [year, month, day] = date.split("-");
  return `${day}-${month}-${year}`;
}

class VendorInvoiceComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      invoice_id: "",
      vendor_id: "",
      invoice_date: "",
      invoice_amount: "",
      status: "NOTPAID",
    };
  }

  updateInvoiceState = (invoice) => {
    this.setState({
      invoice_id: invoice.id,
      vendor_id: invoice.vendor_id,
      invoice_date: invoice.invoice_date,
      invoice_amount: invoice.invoice_amount,
      status: invoice.status,
    });
  };

  

  render() {
    // Apply filters
    let filteredInvoices = this.props.invoices;

    if (this.props.filterVendorId) {
      filteredInvoices = filteredInvoices.filter(
        (inv) => inv.vendor_id === this.props.filterVendorId
      );
    }
    if (this.props.filterFromDate) {
      filteredInvoices = filteredInvoices.filter(
        (inv) => inv.invoice_date >= this.props.filterFromDate
      );
    }
    if (this.props.filterToDate) {
      filteredInvoices = filteredInvoices.filter(
        (inv) => inv.invoice_date <= this.props.filterToDate
      );
    }
    if (this.props.filterStatus) {
      filteredInvoices = filteredInvoices.filter(
        (inv) => inv.status === this.props.filterStatus
      );
    }

    return (
      <div>
        {/* Add Invoice Modal */}
        <div
          id="invoiceModal"
          className="modal fade"
          tabIndex="-1"
          role="dialog"
          aria-hidden="true"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">Add Vendor Invoice</h4>
                <button type="button" className="close" data-dismiss="modal">
                  <span>&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <form id="vendorupdateform">
                  {/* Vendor Dropdown */}
                  <div className="form-group">
                    <label>Vendor</label>
                    <select
                      className="form-control"
                      value={this.props.selectedVendor}
                      onChange={this.props.onVendorChange}
                    >
                      <option value="">Select Vendor</option>
                      {this.props.vendors &&
                        this.props.vendors.map((v, idx) => (
                          <option key={idx} value={v.id}>
                            {v.vendor_name}
                          </option>
                        ))}
                    </select>
                  </div>

                  <div className="form-group">
                    <label>Invoice Date</label>
                    <input
                      type="date"
                      className="form-control"
                      onChange={this.props.onInvoiceDateChange}
                    />
                  </div>

                  <div className="form-group">
                    <label>Invoice Amount</label>
                    <input
                      type="number"
                      className="form-control"
                      onChange={this.props.onInvoiceAmountChange}
                    />
                  </div>

                  <div className="form-group">
                    <label>Status</label>
                    <select
                      className="form-control"
                      value={this.props.status}
                      onChange={this.props.onStatusChange}
                    >
                      <option value="NOTPAID">Not Paid</option>
                      <option value="PAID">Paid</option>
                      <option value="PARTIAL">Partially Paid</option>
                    </select>
                  </div>

                  {/* 🔹 File Upload */}
                  <div className="form-group">
                    <label>Upload Invoice Photo</label>
                    <input
                      type="file"
                      className="form-control"
                      accept="image/*,.pdf"
                      onChange={this.props.onInvoiceFileChange}
                    />
                  </div>

                  <button
                    type="submit"
                    className="btn btn-primary"
                    onClick={this.props.addInvoice}
                    data-dismiss="modal"
                  >
                    Add Invoice
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>

        {/* 🔹 Edit Invoice Modal */}
        <div
          id="invoiceEditModal"
          className="modal fade"
          tabIndex="-1"
          role="dialog"
          aria-hidden="true"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">Edit Invoice</h4>
                <button type="button" className="close" data-dismiss="modal">
                  <span>&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <form id="vendorform">
                  <div className="form-group">
                    <label>Vendor</label>
                    <select
                      className="form-control"
                      value={this.state.vendor_id}
                      onChange={(e) =>
                        this.setState({ vendor_id: e.target.value })
                      }
                    >
                      {this.props.vendors &&
                        this.props.vendors.map((v, idx) => (
                          <option key={idx} value={v.id}>
                            {v.vendor_name}
                          </option>
                        ))}
                    </select>
                  </div>

                  <div className="form-group">
                    <label>Invoice Date</label>
                    <input
                      type="date"
                      className="form-control"
                      value={this.state.invoice_date}
                      onChange={(e) =>
                        this.setState({ invoice_date: e.target.value })
                      }
                    />
                  </div>

                  <div className="form-group">
                    <label>Invoice Amount</label>
                    <input
                      type="number"
                      className="form-control"
                      value={this.state.invoice_amount}
                      onChange={(e) =>
                        this.setState({ invoice_amount: e.target.value })
                      }
                    />
                  </div>

                  <div className="form-group">
                    <label>Status</label>
                    <select
                      className="form-control"
                      value={this.state.status}
                      onChange={(e) =>
                        this.setState({ status: e.target.value })
                      }
                    >
                      <option value="NOTPAID">Not Paid</option>
                      <option value="PAID">Paid</option>
                      <option value="PARTIAL">Partially Paid</option>
                    </select>
                  </div>

                  <button
                    type="submit"
                    className="btn btn-primary"
                    onClick={(e) => {
                      e.preventDefault();
                      this.props.updateInvoice(this.state);
                    }}
                    data-dismiss="modal"
                  >
                    Update
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>

        {/* Invoices Table */}
        <div className="card">
          <div
            className="card-header d-flex justify-content-between align-items-center flex-wrap"
            style={{ gap: "10px" }}
          >
            <h3 className="h4">Vendor Invoices</h3>
            <div className="d-flex flex-wrap" style={{ gap: "10px" }}>
              {/* Vendor Filter */}
              <select
                className="form-control"
                value={this.props.filterVendorId}
                onChange={this.props.onFilterVendorChange}
              >
                <option value="">All Vendors</option>
                {this.props.vendors &&
                  this.props.vendors.map((v, idx) => (
                    <option key={idx} value={v.id}>
                      {v.vendor_name}
                    </option>
                  ))}
              </select>

              {/* Status Filter */}
              <select
                className="form-control"
                value={this.props.filterStatus}
                onChange={this.props.onFilterStatusChange}
              >
                <option value="">All Status</option>
                <option value="PAID">Paid</option>
                <option value="NOTPAID">Not Paid</option>
                <option value="PARTIAL">Partially Paid</option>
              </select>

              {/* Date Range Filter */}
              <input
                type="date"
                className="form-control"
                value={this.props.filterFromDate}
                onChange={this.props.onFilterFromDateChange}
              />
              <input
                type="date"
                className="form-control"
                value={this.props.filterToDate}
                onChange={this.props.onFilterToDateChange}
              />

              {/* Reset Filters */}
              <button
                className="btn btn-secondary"
                onClick={this.props.onResetFilters}
              >
                Reset Filters
              </button>

              {/* Export Button */}
              <button
                className="btn btn-success"
                onClick={() => this.props.onExport(filteredInvoices)}
              >
                Export to Excel
              </button>

              <button
                className="btn btn-primary"
                data-toggle="modal"
                data-target="#invoiceModal"
              >
                Add Invoice
              </button>
            </div>
          </div>

          <div className="card-body">
            <div className="table-responsive">
              <table className="table text-center">
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Vendor Name</th>
                    <th>Invoice Date</th>
                    <th>Invoice Amount</th>
                    <th>Status</th>
                    <th>BalancePayment</th>
                    <th>Uploaded Date</th>
                    <th>Invoice File</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredInvoices && filteredInvoices.length > 0 ? (
                    filteredInvoices.map((invoice, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>
                          {
                            this.props.vendors.find(
                              (v) => v.id === invoice.vendor_id
                            )?.vendor_name
                          }
                        </td>
                        <td>{formatDateTimeToDisplay(invoice.invoice_date)}</td>
                        <td>{invoice.invoice_amount}</td>
                        <td>
                          <span
                            className={
                              invoice.status === "PAID"
                                        ? "badge badge-success"
                                        : invoice.status === "NOTPAID"
                                        ? "badge badge-warning"
                                        : invoice.status === "PARTIAL"
                                        ? "badge badge-info"        // blue for partial
                                        : invoice.status === "OVERPAID"
                                        ? "badge badge-danger"      // red for overpaid
                                        : "badge badge-secondary"   // fallback
                            }
                          >
                            {invoice.status}
                          </span>
                        </td>
                        <td>{invoice.balance_amount}</td>
                        <td>{formatDateTimeToDisplay(invoice.uploaded_date)}</td>

                        {/* 🔹 Invoice File Link */}
                        <td>
                          {invoice.invoiceFileUrl ? (
                            <a
                              href={invoice.invoiceFileUrl}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="btn btn-sm btn-outline-info"
                            >
                              View
                            </a>
                          ) : (
                            <span className="text-muted">No File</span>
                          )}
                        </td>

                        <td>
                          <i
                            className="fa fa-edit mr-2"
                            data-toggle="modal"
                            data-target="#invoiceEditModal"
                            onClick={() => this.updateInvoiceState(invoice)}
                          ></i>
                          <i
                            className="fa fa-trash"
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              if (
                                window.confirm(
                                  "Are you sure you want to delete this invoice?"
                                )
                              ) {
                                this.props.deleteInvoice(invoice.id);
                              }
                            }}
                          ></i>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="8">No Invoices Found</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  }
  
}

export default VendorInvoiceComponent;
